import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/tg/AuthContext";
import { I18nProvider } from "@/i18n";
import Loading from "@/routes/Loading";
import Home from "@/routes/Home";
import Section from "@/routes/Section";
import Detail from "@/routes/Detail";
import About from "@/routes/About";
import ComingSoon from "@/routes/ComingSoon";
import AdminHome from "@/routes/admin/AdminHome";
import AdminEdit from "@/routes/admin/AdminEdit";
import AppShell from "@/components/AppShell";
import NewsScreen from "@/routes/NewsScreen";
import LevelsMerch from "@/routes/LevelsMerch";
import SupportScreen from "@/routes/SupportScreen";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Splash — full-screen, no shell */}
            <Route path="/" element={<Loading />} />

            {/* Full-screen routes — no bottom nav */}
            <Route path="/detail/:kind/:id" element={<Detail />} />
            <Route path="/about" element={<About />} />
            <Route path="/section/:kind" element={<Section />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/edit/:id?" element={<AdminEdit />} />

            {/* Tab routes — wrapped in AppShell (shared bottom nav) */}
            <Route element={<AppShell />}>
              <Route path="/home" element={<Home />} />
              <Route path="/levels" element={<LevelsMerch />} />
              <Route path="/news" element={<NewsScreen />} />
              <Route path="/support" element={<SupportScreen />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
